/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { 
    Routes, 
    Route, 
    Navigate
} from "react-router-dom";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion
//#region Services
import {  userHasPermission } from "config/userPermissions";
//#endregion
import useDashboardContext from "routes/utils/context/useDashboardContext";
import { APPOINTMENT_MODULES } from "./utils/constants";

/*
# Credenciales

* Gabriela Bohorquez Toledo - Coordinador Asesorías
* Gladys Pacheco - Psicologo
*/

const Appointment = () => {
    const { user } = useDashboardContext();
    const userRole = user.role.id;
    //#region States
    const [routes, setRoutes] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        setRoutes(getRoutes());
    }, []);
    //#endregion
    //#region Functions
    const getRoutes = () => {
        return APPOINTMENT_MODULES
            .filter(({ id }) => userHasPermission(userRole, id))
            .map(({ id, path, View }) => (
                <Route 
                    key={path}
                    path={path} 
                    element={<View userRole={userRole}/>}/>
            ));
    }
    //#endregion
    return (
        <Routes>
            {routes}
            {routes !== null && (
                <Route 
                    path="*" 
                    element={<Navigate to={ABSOLUTE_PATHS.APPOINTMENT} 
                    replace/>}/>
            )}
        </Routes>
    );
}

export default Appointment;